import {inputReadonlyDesign} from "../inputClass";
import React from "react";

export const ContanctDetailPopUp = ({fn}) => {
    return (
        <div className={`w-full h-screen bg-black/60 fixed top-[5%] left-0 flex justify-center items-center px-[20%]`} onClick={()=>{
            fn()
        }}>
            <div className={`w-full bg-white py-8 px-12 rounded-3xl z-30 `}
                 onClick={(e) => e.stopPropagation()}
            >
                <h1 className={`font-bold text-2xl mb-3`}>1:1 문의</h1>
                <div className={`flex gap-3`}>
                    <div className={`w-[20%]`}>
                        <input type="text" className={inputReadonlyDesign} value={"결제관련"}/>
                    </div>
                    <div className={`w-[80%]`}>
                        <input type="text" className={inputReadonlyDesign} value={"제목이 표시되는 영역입니다"}/>
                    </div>
                </div>
                <div className={`my-3`}>
                    <textarea name="" id="" cols="33" rows="5"
                              className={`h-auto ${inputReadonlyDesign}`}
                    value={"문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. 문의한 내용이 표시 되는 영역입니다. "}
                    ></textarea>
                </div>
                <div className={`flex gap-3`}>
                    <div className={`py-4 px-5 bg-gray-50 text-gray-700 flex justify-between flex-grow rounded-lg`}>
                        <div>name.jpg</div>
                        <div>삭제</div>
                    </div>
                    <button className={`py-4 px-5 bg-white font-bold border-2 rounded-lg`}>+파일 첨부</button>
                </div>
                
                <div className={`mt-10`}>
                    <h1 className={`mb-2 font-bold text-2xl`}>답변내역</h1>
                    <textarea name="" id="" cols="33" rows="5"
                              className={`h-auto ${inputReadonlyDesign}`}
                              value={"답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. 답변한 내용이 표시되는 영역입니다. "}
                    ></textarea>
                </div>
            </div>
        
        </div>
    )
}